export default {
  CHL_REPORT_DETAIL_REQUEST: 'APP/CHL_REPORT_DETAIL/CHL_REPORT_DETAIL_REQUEST',
  CHL_REPORT_DETAIL_SUCCESS: 'APP/CHL_REPORT_DETAIL/CHL_REPORT_DETAIL_SUCCESS',
  CHL_REPORT_DETAIL_ERROR: 'APP/CHL_REPORT_DETAIL/CHL_REPORT_DETAIL_ERROR',
};
